import { GalaxyConfig, StarData, StarPosition } from 'types/galaxy';

const getTier = (star: StarData): number => {
  if (star.f_roi > 20) return 0;
  if (star.f_roi > 0) return 1;
  if (star.pnl > 0) return 2;
  if (star.pnl > -500) return 3;
  return 4;
};

export const calculateTiersPositions = (
  starsData: StarData[],
  _config: GalaxyConfig
): StarPosition[] => {
  const ringRadii = [14, 28, 44, 60, 78];
  const ringWidth = [6, 8, 10, 10, 12];
  const ringThickness = [1.5, 2, 2.5, 2.5, 3];

  const positions: StarPosition[] = new Array(starsData.length);

  // Group by tier
  const tiers: number[][] = [[], [], [], [], []];
  starsData.forEach((star, i) => {
    tiers[getTier(star)].push(i);
  });

  tiers.forEach((indices, tier) => {
    const count = indices.length;
    if (count === 0) return;
    indices.forEach((idx, j) => {
      const angle = (j / count) * Math.PI * 2 + tier * 0.618;
      const r = ringRadii[tier] + (Math.random() - 0.5) * ringWidth[tier];
      const y = (Math.random() - 0.5) * ringThickness[tier];
      positions[idx] = {
        x: Math.cos(angle) * r,
        y,
        z: Math.sin(angle) * r,
      };
    });
  });

  return positions;
};
